import React, { useContext, useState, useEffect, useCallback } from "react";
import { LTabStrip, LButton, LGrid, LDialog, LFade } from "@loffa/gpp-modules";
import { AuthContext } from "../../../../context/AuthContext";
import KeyBasedLButton from "../../../Shared/KeyBasedLButton";

function ServiceManagement() {
  const context = useContext(AuthContext);
  const [dtcData, setDTCData] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;

  const SeedDTCDatabase = async () => {
    let header = {
      Authorization: `Bearer ${context.authState().accessToken.accessToken}`,
      "Content-Type": "application/json",
    };

    let init = { method: 'GET', accept: 'application/json', headers: header, timeout: 10000 };
    let url = GATEWAY_BASE + "/multitenancy/api/Integration/UpdateAllDTCs";

    fetch(url, init)
      .then(response => response.json())
      .then(json => {
        setDTCData({ json });
      });
  };

  const GetDTCData = useCallback(async () => {
    let header = {
      Authorization: `Bearer ${context.authState().accessToken.accessToken}`,
      "Content-Type": "application/json",
    };

    let init = { method: 'GET', accept: 'application/json', headers: header, timeout: 10000 };
    let url = GATEWAY_BASE + "/multitenancy/api/Integration/GetAllDTCs";

    fetch(url, init)
      .then(response => response.json())
      .then(json => {
        setDTCData(json);
      });
  }, [GATEWAY_BASE, context]);

  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!itemToDelete) return;
    try {
      const response = await fetch(
        `${GATEWAY_BASE}/multitenancy/api/Integration/DeleteDTC/${itemToDelete.Id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${context.authState().accessToken.accessToken}`,
          },
        }
      );
      if (!response.ok) throw new Error("Failed to delete DTC.");
      GetDTCData();
    } catch (err) {
      console.error("Error deleting DTC: ", err);
    } finally {
      setItemToDelete(null);
      setIsDeleteModalOpen(false);
    }
  };

  useEffect(() => {
    if (dtcData == null) {
      GetDTCData();
    }
  }, [GetDTCData, dtcData]);

  const onDeleteDialogClose = () => {
    setIsDeleteModalOpen(false);
    setItemToDelete(null);
  };

  return (
    <div>
      <LTabStrip
        tabs={[
          {
            title: "FVD Integration",
            body: (
              <div>


                <LGrid
                  sortable
                  filterable
                  pageable
                  height="400px"
                  data={dtcData}
                  columns={[
                    {
                      field: "actions",
                      title: "Actions",
                      width: 125,
                      cell: (props) => (
                        <td>
                          <KeyBasedLButton
                            parentKey={props.dataItem.Id}
                            themeColor="error"
                            onClick={() => handleDeleteClick(props.dataItem)}
                            buttonText="Delete"
                          >
                          </KeyBasedLButton>
                        </td>
                      ),
                    },
                    {
                      field: "DTC",
                      title: "DTC",
                    },
                    {
                      field: "ClientProductGuid",
                      title: "ClientProductGuid",
                    },
                    {
                      field: "ClientName",
                      title: "Client Name"
                    },
                    {
                      field: "ProductName",
                      title: "Product Name"
                    },
                    {
                      field: "ProductType",
                      title: "Product Type"
                    }
                  ]}
                ></LGrid>

              </div>
            ),
          },
          {
            title: "Other Tab",
            disabled: true,
            body: (
              <div>
                <h4>Other</h4>
                <p>Coming soon...</p>
              </div>
            ),
          },
        ]}
      />
      {isDeleteModalOpen && itemToDelete && (
        <LFade transitionEnterDuration={300}>
          <LDialog
            width="400"
            title="Confirm Delete"
            actionLayout="end"
            body={`Are you sure you want to delete DTC ${itemToDelete?.DTC}?`}
            action={
              itemToDelete && (<>
                <KeyBasedLButton parentKey={itemToDelete.Id} onClick={() => setIsDeleteModalOpen(false)} buttonText="Cancel"></KeyBasedLButton>
                <KeyBasedLButton parentKey={itemToDelete.Id} themeColor="primary" onClick={handleConfirmDelete} buttonText="Delete"></KeyBasedLButton>
              </>)
            }
            actionCloseButton={onDeleteDialogClose}
            actionOverlay={onDeleteDialogClose}
          />
        </LFade>
      )}
    </div>
  );
}

export { ServiceManagement };
